import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum PrimeAwardType {
  Grant = 'grant',
  GrantWithConditions = 'grant-with-conditions',
  ContractOrSubcontract = 'contract-or-subcontract',
}
const PRIME_AWARD_TYPES: ReadonlySet<PrimeAwardType> = new Set(
  Object.values(PrimeAwardType) as PrimeAwardType[],
)
export namespace PrimeAwardType {
  export const ALL: readonly PrimeAwardType[] = Array.from(PRIME_AWARD_TYPES)
  export const isPrimeAwardType = TypeChecker.Factory.oneOf(PRIME_AWARD_TYPES)
  export const assertIsPrimeAwardType: TypeAsserter<PrimeAwardType> =
    TypeAsserter.Factory.from(isPrimeAwardType)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link PrimeAwardType}
   */
  export function getEntry(
    primeAwardType: PrimeAwardType,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[primeAwardType], id: primeAwardType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    PrimeAwardType,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [PrimeAwardType.Grant]: {
      name: 'Grant',
    },
    [PrimeAwardType.GrantWithConditions]: {
      name: 'Grant with conditions',
    },
    [PrimeAwardType.ContractOrSubcontract]: {
      name: 'Contract or Subcontract',
    },
  }
}
